const store = {
    namespaced: true,
    state() {
        return {
            orders: [],
            page: 1,
            totalPagesCount: 1,
            totalCount: 0,
            isOrdersLoaded: false,
            ordersLength: 0,
        };
    },
    getters: {
        getOrders(state) {
            return state.orders;
        },
        getPage(state) {
            return state.page;
        },
        getTotalPagesCount(state) {
            return state.totalPagesCount;
        },
        getTotalCount(state) {
            return state.totalCount;
        },
        getIsOrdersLoaded(state) {
            return state.isOrdersLoaded;
        },
        getOrdersLength(state) {
            return state.ordersLength;
        },
    },
    mutations: {
        SET_ORDERS(state, orders) {
            state.orders = orders;
        },
        SET_PAGE(state, page) {
            state.page = page;
        },
        SET_TOTAL_PAGE_COUNT(state, totalPagesCount) {
            state.totalPagesCount = totalPagesCount;
        },
        SET_TOTAL_COUNT(state, totalCount) {
            state.totalCount = totalCount;
        },
        SET_IS_ORDERS_LOADED(state, isOrdersLoaded) {
            state.isOrdersLoaded = isOrdersLoaded;
        },
        SET_ORDERS_LENGTH(state, ordersLength) {
            state.ordersLength = ordersLength;
        },
    },
    actions: {
        async fetchOrderHistory({ commit, getters }, { page = 0 } = {}) {
            commit('SET_IS_ORDERS_LOADED', false);
            let url = '/general/v2/order/';

            if (page) {
                url += `?page=${page}`;
                commit('SET_PAGE', page);
            }

            try {
                const response = await this.$axios.$get(url);

                commit('SET_ORDERS', response.data);
                commit('SET_ORDERS_LENGTH', response.data.length);
                commit('SET_TOTAL_COUNT', response.totalCount);
                commit('SET_TOTAL_PAGE_COUNT', response.pages);
                commit('SET_IS_ORDERS_LOADED', true);
            } catch (e) {
                console.error(e);
            } finally {
                //
            }
        },
        async changePage({ commit }, { query, page }) {
            if (!page) {
                page = 1;
            }
            commit('SET_PAGE', page);

            if (process.server) {
                return;
            }

            if (page !== 1) {
                await this.$router.push({ query: { ...query, page: page } });
                return;
            }

            const newQuery = { ...query };
            delete newQuery.page;

            await this.$router.push({ query: newQuery });
        },
        async fetchFilteredOrders({ commit }, { search = '', status = '', startDate = '', endDate = '', companyIds = [] } = {}) {
            commit('SET_IS_ORDERS_LOADED', false);
            let queryParams = [];

            if (search) {
                queryParams.push(`search=${encodeURIComponent(search)}`);
            }

            if (status && status !== 'all') {
                queryParams.push(`status=${encodeURIComponent(status)}`);
            }

            if (startDate && endDate) {
                queryParams.push(`start_date=${startDate}`);
                queryParams.push(`end_date=${endDate}`);
            }

            if (companyIds?.length) {
                queryParams.push(`company_id=${companyIds}`);
            }

            const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';
            const url = `/general/v2/order/${queryString}`;

            try {
                const response = await this.$axios.$get(url);
                // handle response or update state
                commit('SET_ORDERS', response.data);
                commit('SET_ORDERS_LENGTH', response.data.length);
                commit('SET_TOTAL_COUNT', response.totalCount);
                commit('SET_TOTAL_PAGE_COUNT', response.pages);
                commit('SET_IS_ORDERS_LOADED', true);
            } catch (error) {
                console.error('Failed to fetch filtered orders:', error);
            }
        },
    },
};

export default store;
